<template>
  <v-container
    id="line-official-account-create-page"
    class="fill-height justify-center">
    <img
      class="_bench-banner _ps-fixed"
      src="/img/account/bench-banner.jpg"
      loading="lazy"
      alt="Bench Banner Image"
    />
    <v-row
      align-content="center"
      justify="center">
      <v-col lg="8">
        <v-card class="d-flex flex-column justify-center pa-10">
          <div class="d-flex flex-column align-center">
            <account-back-button
              v-if="hasLineOfficialAccount"
              :to="{ name: 'LineOfficialAccountChoose' }"
            >
            </account-back-button>

            <div class="_fs-24 _fs-sm-36">
              กรุณาเพิ่มบัญชีของท่าน
            </div>

            <v-btn
              class="mt-10"
              color="primary"
              height="80"
              rounded
              width="250"
              :to="{ name: 'LineOfficialAccountCreateOld' }"
              @click="trackCurrentCustomerClick"
            >
              <div class="text-center">
                <div class="_fs-20">
                  ลูกค้าปัจจุบัน
                </div>
              </div>
            </v-btn>
            <div class="mt-4 grey--text text-center">
              สำหรับบัญชีที่เคยซื้อแพ็กเกจกับ Sellsuki แล้ว
            </div>

            <v-btn
              class="mt-10"
              color="primary"
              height="80"
              rounded
              width="250"
              outlined
              :to="{ name: 'OrderCreate', params: { productType: 'newLineOfficialAccount' } }"
              @click="trackNewCustomerClick"
            >
              <div class="text-center">
                <div class="_fs-20">
                  ลูกค้าใหม่
                </div>
              </div>
            </v-btn>
            <div class="mt-4 grey--text text-center">
              สำหรับลูกค้าที่ต้องการเปิดบัญชีใหม่/ย้ายบัญชีเข้า Sellsuki
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'LineOfficialAccountCreatePage',
  components: {
    AccountBackButton: () => import('@/components/AccountBackButton.vue')
  },
  computed: {
    ...mapState('User', ['userProfile']),
    lineUid() {
      return this.userProfile?.uid || null
    },
    ...mapGetters({
      hasLineOfficialAccount: 'User/hasLineOfficialAccount',
      activeLineOfficialAccount: 'User/activeLineOfficialAccount'
    })
  },
  methods: {
    trackCurrentCustomerClick() {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'click_current_customer',
        category: 'user_action',
        label: 'existing_customer_btn_login',
        value: 1,
        userId: this.lineUid,
        premium_id: this.activeLineOfficialAccount.premiumId || null,
        basic_id: this.activeLineOfficialAccount.basicId || null,
        customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new'
      })
    },
    trackNewCustomerClick() {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'click_new_customer',
        category: 'user_action',
        label: 'new_customer_btn_login',
        value: 1,
        userId: this.lineUid,
        premium_id: this.activeLineOfficialAccount.premiumId || null,
        basic_id: this.activeLineOfficialAccount.basicId || null,
        customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
._bench-banner {
  width: 100%;
  bottom: 0;

  @media only screen and (min-width: 1264px) {
    width: calc(100% - 220px);
    left: 220px;
    bottom: 10%;
  }
}
</style>
